module.exports = __webpack_public_path__ + "static/drt5-af4cd28fdc4621e105b7f7391279e0fc.jpg";